import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import Footer from "../../components/footer/Footer.jsx";
import Scrollbar from "../../components/scrollbar/scrollbar";

const ServicePage = () => {
  return (
    <Fragment>
      <Navbar />
      {/* Removed PageTitle to eliminate the duplicate "Services / Home > Services" bar */}
      <ServiceSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default ServicePage;